import * as statusesCreators from "./statusesAction";
import * as pathologyCreators from "./pathologyAction";
import * as uploadCreators from "./uploadAction";
import * as userAction from "./userAction";
export default {
  ...statusesCreators,
  ...pathologyCreators,
  ...uploadCreators,
  ...userAction,
};
